import React, { Component } from "react";
import CustomSlider from "./CustomSlider";
import HoverGraphic from "./HoverGraphic";
import * as d3 from "d3";

class Map extends Component {
  $svg = React.createRef();

  setupBasemap = () => {
    d3.json("./data/map_shape_data.json").then((data) => {
      const geoGenerator = d3
        .geoPath()
        .projection(d3.geoMercator().scale(30000).translate([39590, 23555]));

      d3.select(this.$svg.current)
        .select("g")
        .selectAll("path")
        .data(data.features)
        .enter()
        .append("path")
        .attr("class", "feature-path")
        .attr("d", geoGenerator)
        .style("fill", "white");

      this.handleYearChange(null, 2016);
    });
  };

  handleYearChange = (_event, value) => {
    const calcLeft = () => {
      const graphicWidth = this.$svg.current.clientWidth;
      const hoverWidth = d3.select("#map-hoverbox").node().clientWidth;
      if (d3.event.x < hoverWidth / 2) {
        return `${d3.event.x}px`;
      } else if (d3.event.x + hoverWidth / 2 > graphicWidth) {
        return `${d3.event.x - hoverWidth}px`;
      } else {
        return `${d3.event.x - hoverWidth / 2}px`;
      }
    };
    d3.selectAll(".feature-path")
      .on("touchstart", () => {
        d3.event.preventDefault();
      })
      .on("pointerover pointermove", () => {
        const hoverHeight = d3.select("#map-hoverbox").node().offsetHeight;
        const d = document.elementFromPoint(d3.event.x, d3.event.y).__data__;
        if (d) {
          this.setState({
            title: d.properties.Precinct,
            d_name: "Democrat",
            r_name: "Republican",
            d_val: d.properties[`Dem_${value}`],
            r_val: d.properties[`Rep_${value}`],
          });
          d3.select("#map-hoverbox")
            .style("opacity", 1)
            .style("top", `${d3.event.y - hoverHeight}px`)
            .style("left", calcLeft);
        }
      })
      .on("pointerout", () => {
        d3.select("#map-hoverbox").style("opacity", 0);
      })
      .transition()
      .delay((_d, i) => 2 * i)
      .style("fill", (d) => {
        const mov = d.properties[`Dem_${value}`] - d.properties[`Rep_${value}`];
        if (isNaN(mov)) {
          return "grey";
        } else {
          const scaled = (mov + 100) / 200;
          return d3.interpolateRdBu(scaled);
        }
      });
  };

  componentDidMount() {
    this.setupBasemap();
  }

  setLabel = (label) => {
    switch (label) {
      case 2000:
        return "Bush vs. Gore";
      case 2004:
        return "Bush vs. Kerry";
      case 2008:
        return "Obama vs. McCain";
      case 2012:
        return "Obama vs. Romney";
      case 2016:
        return "Trump vs. Clinton";
      default:
        return "";
    }
  };

  render() {
    return (
      <section id="map-section">
        <h2 className="section-title">
          Presidential Election Results by Precinct
        </h2>
        <CustomSlider
          track={false}
          defaultValue={2016}
          step={4}
          min={2000}
          max={2016}
          marks={[
            { value: 2000, label: 2000 },
            { value: 2004, label: 2004 },
            { value: 2008, label: 2008 },
            { value: 2012, label: 2012 },
            { value: 2016, label: 2016 },
          ]}
          valueLabelDisplay="on"
          valueLabelFormat={this.setLabel}
          onChange={this.handleYearChange}
        />
        <div id="map-graphic-container">
          <svg
            viewBox={[0, 0, 300, 300]}
            preserveAspectRatio="xMidYMid meet"
            ref={this.$svg}
          >
            <g id="feature-container"></g>
          </svg>
          <div id="map-hoverbox" className="hoverbox">
            {this.state && (
              <HoverGraphic
                title={this.state.title}
                d_name={this.state.d_name}
                r_name={this.state.r_name}
                d_val={this.state.d_val}
                r_val={this.state.r_val}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Map;
